import { useMutation } from 'react-query'

import { Account } from '@modules-deprecated/app/accounts/types'

import { APIError } from '../../../utils'
import {
  createNewBookkeepingBankAccount,
  CreateNewBookkeepingBankAccountProps,
  CreateNewBookkeepingBankAccountResponse,
} from '../query-api'

interface UseCreateBookkeepingBankAccountProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: Account) => void
}

export const useCreateBookkeepingBankAccount = (props: UseCreateBookkeepingBankAccountProps = {}) => {
  const { onError, onSuccess } = props || {}

  const { mutate: createBookkeepingBankAccount, isLoading: isProcessing } = useMutation(
    ({ organizationId, newBankAccountPayload }: CreateNewBookkeepingBankAccountProps) =>
      createNewBookkeepingBankAccount({ organizationId, newBankAccountPayload }),
    {
      onError: (error: APIError) => {
        onError?.(error)
      },
      onSuccess: (data: CreateNewBookkeepingBankAccountResponse) => {
        onSuccess?.(data?.account)
      },
    },
  )

  return { createBookkeepingBankAccount, isProcessing }
}
